var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7C8.44772 7 8 7.46903 8 8.04762V16.9524C8 17.531 8.44772 18 9 18H10.5C10.7761 18 11 17.7761 11 17.5V15.119C11 14.9744 11.1119 14.8571 11.25 14.8571H13.75C13.8881 14.8571 14 14.9744 14 15.119V17.5C14 17.7761 14.2239 18 14.5 18H16C16.5523 18 17 17.531 17 16.9524V8.04762C17 7.46904 16.5523 7 16 7H9ZM10.25 8.04762C10.1119 8.04762 10 8.16488 10 8.30952V9.35714C10 9.50179 10.1119 9.61905 10.25 9.61905H11.75C11.8881 9.61905 12 9.50179 12 9.35714V8.30952C12 8.16488 11.8881 8.04762 11.75 8.04762H10.25ZM13 8.30952C13 8.16488 13.1119 8.04762 13.25 8.04762H14.75C14.8881 8.04762 15 8.16488 15 8.30952V9.35714C15 9.50179 14.8881 9.61905 14.75 9.61905H13.25C13.1119 9.61905 13 9.50179 13 9.35714V8.30952ZM10.25 10.1429C10.1119 10.1429 10 10.2601 10 10.4048V11.4524C10 11.597 10.1119 11.7143 10.25 11.7143H11.75C11.8881 11.7143 12 11.597 12 11.4524V10.4048C12 10.2601 11.8881 10.1429 11.75 10.1429H10.25ZM13 10.4048C13 10.2601 13.1119 10.1429 13.25 10.1429H14.75C14.8881 10.1429 15 10.2601 15 10.4048V11.4524C15 11.597 14.8881 11.7143 14.75 11.7143H13.25C13.1119 11.7143 13 11.597 13 11.4524V10.4048ZM10.25 12.2381C10.1119 12.2381 10 12.3554 10 12.5V13.5476C10 13.6923 10.1119 13.8095 10.25 13.8095H11.75C11.8881 13.8095 12 13.6923 12 13.5476V12.5C12 12.3554 11.8881 12.2381 11.75 12.2381H10.25ZM13 12.5C13 12.3554 13.1119 12.2381 13.25 12.2381H14.75C14.8881 12.2381 15 12.3554 15 12.5V13.5476C15 13.6923 14.8881 13.8095 14.75 13.8095H13.25C13.1119 13.8095 13 13.6923 13 13.5476V12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon-account.3e0c94f4feab6bb3e9f3fbf9ddcffe20.svg";
export { ForwardRef as ReactComponent };